import api from '@/api'
import * as types from './types'

export default {
  initBusinessModel({ commit }, data) {
    commit(types.INIT_BUSINESS_DATA, data)
  },
  setActiveTab({ commit, state }, tab) {
    commit(types.SET_ACTIVE_TAB, tab)
  },
  showModal({ commit }, modal) {
    commit(types.SET_DISCOUNT_MODAL, modal)
  },
  setSource({ commit }, source) {
    commit(types.SET_SOURCE, source)
  },
  addNewUserToList({ commit, rootState }, defaultTitleId) {
    // Note: For now, we are only reusing users-tab component for users under a business
    //       and for sales representatives under admin area. For that, this approach is enough.
    //       Right now, if defaultTitleId isn't empty, we automatically deduct that we are inserting a new sales rep
    if (defaultTitleId) {
      commit('admin/ADD_SALES_REPRESENTATIVE', defaultTitleId, { root: true })
    } else {
      commit(types.ADD_NEW_USER_TO_LIST, defaultTitleId)
    }
  },
  copyBillingAddressFromDefault({ commit, state }, isBillingSameAsDefault) {
    var address
    if (isBillingSameAsDefault) {
      address = state.business.primaryAddress
    } else {
      address = {
        street: null,
        city: null,
        state: null,
        postalCode: null,
        country: null,
        language: 1
      }
    }

    commit(types.COPY_BILLING_ADDRESS_FROM_DEFAULT, address)
  },
  getBusinesses({ commit }, data) {
    api.getBusinesses(data)
      .then(response => {
        commit(types.SET_BUSINESSES, response.data)
      })
  },
  upsertBusiness({ commit, state }) {
    commit(types.SET_LOADING, { button: 'upsertBusiness', show: true })
    return new Promise((resolve, reject) => {
      api.upsertBusiness(state.business)
        .then(response => {
          commit(types.SET_BUSINESS_SID, response.data)

          alert('Saved successfully!')

          resolve(response)
        })
        .catch(error => {
          alert(error.response.data)
          reject(error)
        })
        .then(() => commit(types.SET_LOADING, { button: 'upsertBusiness', show: false }))
    })
  },
  swapShop({ commit, state }) {
    commit(types.SET_LOADING, { button: 'swapShop', show: true })
    return new Promise((resolve, reject) => {
      api.swapShop({oldShopId: state.business.id, newShopId: state.business.shopId})
        .then(response => {
          api.getBusinessLocation(state.business.sid)
            .then(response => {
              if (response.status === 200) {
                commit(types.SET_LOCATION, response.data)
              }
              resolve(response)
            })
          alert('Saved successfully!')

          resolve(response)
        })
        .catch(error => {
          alert(error.response.data.errorMessage)
          reject(error)
        })
        .then(() => commit(types.SET_LOADING, { button: 'swapShop', show: false }))
    })
  },
  setBusinessStatus({ commit }, data) {
    return new Promise((resolve, reject) => {
      api.setBusinessStatus(data)
        .then(response => {
          commit(types.SET_BUSINESS_STATUS, data)
          resolve(response)
        })
        .catch(error => {
          alert(error.response.data)
          reject(error)
        })
    })
  },
  upsertBusinessUser({ commit, state }) {
    // Start loading
    commit(types.SET_LOADING, { button: 'upsertBusinessUser', show: true })

    // Create an array of promises based on users' list
    const promises = state.business.users.map(user => {
      // Append sid to user object
      user.sid = state.business.sid
      // Account for known bad null values
      if (user.receivesReportsOnly === undefined || user.receivesReportsOnly === null) {
        user.receivesReportsOnly = false
      }
      if (user.receivesChatReports === undefined || user.receivesChatReports === null) {
        user.receivesChatReports = false
      }
      console.log('Updating User', JSON.stringify(user))
      // Return promise
      return new Promise((resolve, reject) => {
        api.upsertBusinessUser(user)
          .then(response => {
            // Return an object with user (current state) and data (response from API)
            resolve({ user, data: response.data })
          })
          .catch(error => {
            // Notice that we are using "resolve" instead of "reject".
            // the reason is that when using Promise.all, we can't get all the errors from all the promises.
            // We only get the first error of all the promises
            // So, what we are doing is assigning a new Error (with the reason) in the data property,
            // which will be used in our responses under Promise.all().then()
            resolve({ user, data: new Error(error.response.data) })
          })
      })
    })

    // Call promises
    Promise.all(promises)
      .then(responses => {
        var errors = []
        responses.forEach(response => {
          // Check if response is success
          if (response.data instanceof Error) {
            // Add error to errors array
            errors.push({ user: response.user, error: response.data })
          } else {
            // Set new id to user
            commit(types.SET_NEW_USER_ID, { user: response.user, newId: response.data.id })
          }
        })
        return errors
      })
      .then(errors => {
        // Check for errors
        if (errors.length > 0) {
          let msg = 'Error(s) on the following user(s): \n'
          errors.forEach(x => {
            msg += `${x.user.firstName} ${x.user.lastName}: ${x.error.message} \n`
          })

          // Show alert with errors
          alert(msg)
        } else {
          alert('Saved successfully!')
        }
      })
      .then(() => commit(types.SET_LOADING, { button: 'upsertBusinessUser', show: false }))
  },
  removeUser({ commit, state }, user) {
    state.business.users.splice(state.business.users.indexOf(user), 1)
  },
  resetUserPassword({ commit, state }, user) {
    // TODO: Enhance validation in component before submiting this request
    //       We need to validate if password = passwordConfirmation before clicking reset password
    if (user.password === null) {
      alert('Password must be provided.')
      return null
    }
    return new Promise((resolve, reject) => {
      const data = {
        password: user.password,
        resetLockout: user.isLockout,
        id: user.userId
      }
      api.resetUserPassword(data)
        .then(response => {
          alert('User password has been reset successfully!')
          resolve(response)
        })
        .catch(error => {
          alert(error.response.data)
          reject(error)
        })
    })
  },
  upsertBusinessNote({ commit, state }, { note, hasFiles }) {
    // Loading
    commit(types.SET_LOADING, { button: 'upsertBusinessNote', show: true })

    // Data to be sent
    const body = {
      sid: state.business.sid,
      noteId: null,
      text: note.get('note')
    }

    return new Promise((resolve, reject) => {
      api.upsertBusinessNote(body)
        .then(response => {
          if (response.status === 200) {
            var dateCreated = new Date().toISOString()

            var newNote = {
              id: parseInt(response.data),
              text: note.get('note'),
              files: null,
              dateCreated
            }
          }
          resolve(newNote)
        })
        .catch(error => {
          alert(error)
          reject(error)
        })
    })
      .then((newNote) => {
        return new Promise((resolve, reject) => {
          // Upload files
          if (hasFiles) {
            // Add commentId
            note.append('commentId', newNote.id)

            // Progress
            // var config = {
            //   onUploadProgress: function (progressEvent) {
            //     let percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
            //     console.debug('onUploadProgress called with', arguments, 'Percent Completed:' + percentCompleted)
            //   }
            // }

            // Call API
            api.upsertBusinessDocument(note /* , config */)
              .then(response => {
                commit(types.ADD_NOTE_TO_LIST, newNote)
                for (const note of state.business.notes) {
                  if (note.id === newNote.id) {
                    note.files = response.data
                    break
                  }
                }
                // Loading
                commit(types.SET_LOADING, { button: 'upsertBusinessNote', show: false })
                resolve()
              })
              .catch(error => {
                alert('Something went wrong with the files.')
                reject(error)
              })
          } else {
            commit(types.ADD_NOTE_TO_LIST, newNote)
            resolve()
          }
        })
      })
      .then(() => commit(types.SET_LOADING, { button: 'upsertBusinessNote', show: false }))
  },
  upsertBusinessInfo({ commit, state }) {
    commit(types.SET_LOADING, { button: 'upsertBusinessInfo', show: true })

    return new Promise((resolve, reject) => {
      api.upsertBusinessInfo(state.business)
        .then(response => {
          alert('Saved successfully!')

          resolve(response)
        })
        .catch(error => {
          alert(error.response.data)
          reject(error.response.data)
        })
        .then(() => commit(types.SET_LOADING, { button: 'upsertBusinessInfo', show: false }))
    })
  },
  upsertBusinessPromotion({ commit, state }) {
    commit(types.SET_LOADING, { button: 'upsertBusinessPromotion', show: true })
    return new Promise((resolve, reject) => {
      var body = state.business.promotion
      body.sid = state.business.sid
      body.id = state.business.id
      body.startDate = new Date(state.business.promotion.startDate)
      body.endDate = new Date(state.business.promotion.endDate)

      console.log(body.sid)
      api.upsertBusinessPromotion(body)
        .then(response => {
          alert('Saved successfully!')

          resolve(response)
        })
        .catch(error => {
          alert(error.response.data)
          reject(error.response.data)
        })
        .then(() => commit(types.SET_LOADING, { button: 'upsertBusinessPromotion', show: false }))
    })
  },
  upsertBusinessBilling({ commit, state }) {
    commit(types.SET_LOADING, { button: 'upsertBusinessBilling', show: true })

    var body = state.business.billing
    body.sid = state.business.sid

    return new Promise((resolve, reject) => {
      api.upsertBusinessBilling(body)
        .then(response => {
          // Quick hack, since we are not receiving the model back from the API,
          // we just assign it again so that the isCurrencyIdSavedInDatabase will be marked as true
          commit(types.SET_BILLING, state.business.billing)

          console.log('Saved successfully!')

          resolve(response)
        })
        .catch(error => {
          alert(error.response.data)
          reject(error.response.data)
        })
        .then(() => commit(types.SET_LOADING, { button: 'upsertBusinessBilling', show: false }))
    })
  },
  upsertBusinessDiscount({ commit, state }, { mappingTypeId, otherDescriptorId }) {
    var body = {
      mappingTypeId: mappingTypeId,
      otherDescriptorId: otherDescriptorId,
      products: state.business.discounts,
      sid: state.business.sid
    }

    return new Promise((resolve, reject) => {
      api.upsertBusinessDiscount(body)
        .then(response => {
          // Check for failed products
          response.data.forEach((x, i) => {
            if (!x.success) {
              response.data[i] = state.business.discounts.filter(discount => discount.id === x.id)[0]
              response.data[i].success = false
            }
          })

          alert('Saved successfully!')

          resolve(response)
        })
        .catch(error => {
          alert('Something went wrong!' /* error */)
          reject(error)
        })
        .then(() => commit(types.SET_LOADING, { button: 'upsertBusinessBilling', show: false }))
    })
  },
  upsertBusinessProductAddDiscount({ commit, state }) {
    var body = {
      productAdds: [],
      id: parseInt(state.business.id)
    }
    state.business.discountsProductAdds.forEach(element => {
      if (element.isChanged) {
        body.productAdds.push({
          id: parseInt(element.id),
          isTriggerDTC: element.isTriggerDTC,
          isActive: (element.isActive === null) ? 1 : element.isActive,
          discount: {
            typeId: parseInt(element.discount.typeId),
            amount: parseFloat(element.discount.amount)
          }
        })
      }
    })
    console.log('Saving Product Add Discounts', body)
    return new Promise((resolve, reject) => {
      api.upsertDiscountProductAdd(body)
        .then(response => {
          // Check for failed products
          response.data.forEach((x, i) => {
            if (!x.success) {
              response.data[i] = state.business.discountsProductAdds.filter(discount => discount.id === x.id)[0]
              response.data[i].success = false
            }
          })

          alert('Saved successfully!')

          resolve(response)
        })
        .catch(error => {
          alert('Something went wrong!' /* error */)
          reject(error)
        })
        .then(() => commit(types.SET_LOADING, { button: 'upsertBusinessBilling', show: false }))
    })
  },
  modifyManufacturer({ commit }, { manufacturer, event }) {
    var obj = { id: manufacturer.id, percent: document.getElementById('manufacturer_percent_' + manufacturer.name).value }
    if (event.target.checked) {
      commit(types.ADD_MANUFACTURER, obj)
    } else {
      commit(types.REMOVE_MANUFACTURER, obj)
    }
  },
  updateManufacturerPercent({ commit }, { id, event }) {
    commit(types.UPDATE_MANUFACTURER_PERCENT, { id, percent: event.target.value })
  },
  getDistributors({ commit }) {
    api.getDistributors()
      .then(response => {
        if (response.status === 200) {
          commit(types.SET_DISTRIBUTORS, response.data)
        }
      })
  },
  getSalesReps({ commit }) {
    api.getSalesReps()
      .then(response => {
        if (response.status === 200) {
          commit(types.SET_SALES_REPS, response.data)
        }
      })
  },
  addDiscountByVolumeToProduct({ commit }, productIndex) {
    commit(types.ADD_DISCOUNT_BY_VOLUME_TO_PRODUCT, productIndex)
  },
  removeDiscountByVolumeToProduct({ commit }, { discountIndex, productIndex }) {
    commit(types.REMOVE_DISCOUNT_BY_VOLUME_TO_PRODUCT, { discountIndex, productIndex })
  },
  getBusinessLocation({ commit, state }, sid) {
    return new Promise((resolve, reject) => {
      api.getBusinessLocation(sid)
        .then(response => {
          if (response.status === 200) {
            commit(types.SET_LOCATION, response.data)
          }
          resolve(response)
        })
        .catch(error => reject(error))
    })
  },
  getBusinessInfo({ commit }, sid) {
    return new Promise((resolve, reject) => {
      api.getBusinessInfo(sid)
        .then(response => {
          commit(types.SET_INFO, response.data)
          resolve(response)
        })
        .catch(error => reject(error))
    })
  },
  getBusinessPromotion({ commit }, sid) {
    return new Promise((resolve, reject) => {
      api.getBusinessPromotion(sid)
        .then(response => {
          commit(types.SET_PROMOTION, response.data)
          resolve(response)
        })
        .catch(error => reject(error))
    })
  },
  getBusinessUsers({ commit }, sid) {
    return new Promise((resolve, reject) => {
      api.getBusinessUsers(sid)
        .then(response => {
          if (response.status === 200) {
            commit(types.SET_USERS, response.data)
          }
          resolve(response)
        })
        .catch(error => reject(error))
    })
  },
  getBusinessBilling({ commit }, sid) {
    return new Promise((resolve, reject) => {
      api.getBusinessBilling(sid)
        .then(response => {
          if (response.status === 200) {
            commit(types.SET_BILLING, response.data)
          }
          resolve(response)
        })
        .catch(error => reject(error))
    })
  },
  getBusinessDiscounts({ commit, state }, { type, other }) {
    return new Promise((resolve, reject) => {
      api.getBusinessDiscounts({ sid: state.business.sid, type, other })
        .then(response => {
          if (response.status === 200) {
            commit(types.SET_DISCOUNTS, response.data)
          }
          resolve(response)
        })
        .catch(error => reject(error))
    })
  },
  getBusinessProductAddDiscounts({ commit, state }) {
    return new Promise((resolve, reject) => {
      api.getBusinessDiscountsProductAdds({ sid: state.business.sid })
        .then(response => {
          if (response.status === 200) {
            commit(types.SET_DISCOUNTS_PRODUCT_ADDS, response.data)
          }
          resolve(response)
        })
        .catch(error => reject(error))
    })
  },
  getBusinessNotes({ commit }, sid) {
    return new Promise((resolve, reject) => {
      api.getBusinessNotes(sid)
        .then(response => {
          if (response.status === 200) {
            commit(types.SET_NOTES, response.data)
          }
          resolve(response)
        })
        .catch(error => reject(error))
    })
  },
  getDownloadToken({ commit }, fileId) {
    return new Promise((resolve, reject) => {
      api.getDownloadToken(fileId)
        .then(response => {
          resolve(response)
        })
        .catch(error => reject(error))
    })
  },
  resetPeriodData({ commit }) {
    commit(types.RESET_PERIOD_DATA)
  },
  lookupBusiness({ commit, dispatch }, search) {
    return new Promise((resolve, reject) => {
      api.lookupBusiness(search)
        .then(response => {
          resolve(response)
        })
        .catch(error => reject(error))
    })
  },
  getRoles({ commit, dispatch }, type) {
    return new Promise((resolve, reject) => {
      if (type === undefined || type === null) {
        type = '1'
      }
      api.getRoles(type)
        .then(response => {
          if (response.status === 200) {
            commit(types.SET_ROLES, response.data)
          }
          resolve(response)
        })
        .catch(error => reject(error))
    })
  },
  searchBusinesses({ commit, dispatch }, search) {
    return new Promise((resolve, reject) => {
      api.searchBusinesses(search)
        .then(response => {
          if (response.status === 200) {
            commit(types.SET_BUSINESSES_FOUND, response.data)
          }
          resolve(response)
        })
        .catch(error => reject(error))
    })
  },
  getAllBusinessesForDropdowns({ commit }) {
    return new Promise((resolve, reject) => {
      // Get all businesses without pagination and status filter
      api.getBusinesses({
        params: {
          search: '',
          orderBy: 'name',
          sortBy: 'asc',
          status: '',
          pageSize: 10000, // Large number to get all
          offset: 0
        }
      })
      .then(response => {
        console.log('getAllBusinessesForDropdowns response:', response.data)
        console.log('Response data structure:', Object.keys(response.data || {}))
        if (response.data && response.data.results) {
          console.log('Sample business item:', response.data.results[0])
          console.log('Total businesses loaded:', response.data.results.length)
        }

        commit(types.SET_ALL_BUSINESSES, response.data)
        resolve(response.data)
      })
      .catch(error => {
        console.error('Failed to load all businesses for dropdowns:', error)
        reject(error)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/business/actions.js